import { MentionsInputStyled } from '@procurify/ui'
import { em, rem } from 'polished'
import styled from 'styled-components'

interface IChatInputContainerStyledProps {}

export const ChatInputContainerStyled = styled.div<IChatInputContainerStyledProps>`
  font-size: ${rem(12)};

  padding: ${(props) => props.theme.space.medium}
    ${(props) => props.theme.space.large};

  ${MentionsInputStyled} {
    width: 100%;
  }

  .mentions-input-placeholder {
    width: 100%;
    height: ${em(100, 12)};

    font-family: ${(props) => props.theme.fontFamily.body};
    line-height: 1.42;
    outline: none;
    padding: ${(props) => props.theme.space.medium};
    tab-size: 4;
    text-align: left;

    font-style: italic;

    background: ${(props) => props.theme.colors.lightGrey};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    border-radius: ${rem(4)};
    border: 1px solid ${(props) => props.theme.colors.content.border};
    margin: 0;
  }
`
